import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";
import NoData from "../../../components/common/NoData";
import Loading from "../../../components/common/Loading";
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../../Config/FbConfig';
import { Styles } from "../styles/Achievers";


export default class DepartmentResearchFacilities extends Component {

  state = {
    displayModal: false,
    modalFacilityName: "",
    modalIncharge: "",
    modalDescription: "",
    modalUse: "",
    Datas: []
  }

  //Display Modal
  displayModal = (e) => {
    this.setState({
      displayModal: !this.state.displayModal,
    })
  }

  //Display Content
  contentModal = (e) => {
    var result = this.state.Datas.filter((x) => x.Id === e.target.id);
    this.setState({
      displayModal: !this.state.displayModal,
      modalFacilityName: result[0]["Name"],
      modalIncharge: result[0]["Faculty"],
      modalDescription: result[0]["Description"],
      modalUse: result[0]["Use"],
    })
  }

  //Load Data Here
  async componentDidMount() {
    const docRef = doc(firestore, this.props.match.params.id, "ResearchFacility");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      var Data = []
      Object.entries(docSnap.data()).forEach(([key, value]) => {
        Data.push(Object.assign({ Id: key, Priority: value.Priority != undefined ? value.Priority : "999" }, value))
      });
      Data.length === 0 ? this.setState({ Datas: "NO_999" }) : this.setState({ Datas: Data.sort(function (a, b) { return a.Priority - b.Priority; }) })
    } else {
      this.setState({
        Datas: "NO_999"
      })
    }
  }

  render() {
    const banner = {
      cse: <Banner title="Computer Science and Engineering" image="banners/department-cse.jpg" />,
      ise: <Banner title="Information Science and Engineering" image="banners/department-ise.jpg" />,
      ai: <Banner title="Artificial Intelligence and Machine Learning" image="banners/department-ai.jpg" />,
      ece: <Banner title="Electronics and Communication Engineering" image="banners/department-ece.jpg" />,
      mech: <Banner title="Mechanical Engineering" image="banners/department-me.jpg" />,
      civil: <Banner title="Civil Engineering" image="banners/department-me.jpg" />,
      eee: <Banner title="Electrical and Electronics Engineering" image="banners/department-eee.jpg" />,
      ete: <Banner title="Electronics and Telecommunication Engineering" image="banners/department-ete.jpg" />,
      eie: <Banner title="Electronics and Instrumentation Engineering" image="banners/department-eie.jpg" />,
      iem: <Banner title="Industrial Engineering and Management" image="banners/department-iem.jpg" />,
      mba: <Banner title="Master of Business Administration" image="banners/department-mba.jpg" />,
      mca: <Banner title="Master of Computer Applications (MCA)" image="banners/department-mca.jpg" />,
      phy: <Banner title="Physics" image="banners/department-phy.jpg" />,
      chem: <Banner title="Chemistry" image="banners/department-che.jpg" />,
      math: <Banner title="Mathematics" image="banners/department-math.jpg" />,
      hum: <Banner title="Humanities" image="banners/department-hum.jpg" />,
    }

    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        {banner[this.props.match.params.id]}

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">Research Facilities</h4>
                    </div>
                  </div>
                  <div className="ttm-service-description">
                    <div className="row">
                      {
                        this.state.Datas.length === 0 ? <Loading /> :
                          this.state.Datas === "NO_999" ? <NoData /> :
                            this.state.Datas.map((data, i) => (
                              <div className="col-lg-4 col-sm-12 col-md-12 col-xs-12 d-flex align-items-stretch">
                                <div className="no-gutters featured-imagebox featured-imagebox-post ttm-box-view-left-image box-shadow" style={{ borderBottom: "solid", borderColor: "#98002e" }}>
                                  <Styles>
                                    <div className="featured-content" key={i}>
                                      <div className="post-title featured-title">
                                        <h6 style={{ color: "#98002e" }}>{i + 1}. {data.Name}</h6>
                                      </div>
                                      <div className="featured-desc ttm-box-desc justify">
                                        <p>{data.Description}</p>
                                      </div>
                                      <a id={data.Id} className="ttm-btn btn-inline" style={{ marginTop: "1rem" }} onClick={this.contentModal}>Read More <i className="fas fa-angle-double-right" /></a>
                                    </div>
                                  </Styles>
                                </div>
                              </div>
                            ))
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department={this.props.match.params.id} />
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        <Modal size="lg" show={this.state.displayModal} onHide={this.displayModal} centered>
          <Modal.Header closeButton></Modal.Header>
          <div className="no-gutters featured-imagebox featured-imagebox-post ttm-box-view-left-image box-shadow" style={{ borderBottom: "solid", borderColor: "#98002e" }}>
            <div className="featured-content">
              <div className="post-title featured-title">
                <h6 style={{ color: "#98002e" }}>{this.state.modalFacilityName}</h6>
              </div>
              <div className="featured-desc ttm-box-desc">
                <span className="ttm-meta-line"><b>Faculty/Incharge :</b> {this.state.modalIncharge}</span>
              </div>
              <div className="featured-desc ttm-box-desc">
                <span className="ttm-meta-line"><b>Description :</b> {this.state.modalDescription}</span>
              </div>
              <div className="featured-desc ttm-box-desc">
                <span className="ttm-meta-line"><b>Application/Use :</b> {this.state.modalUse}</span>
              </div>
            </div>
          </div>
        </Modal>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}